import React from 'react';
import { useStyles } from '../../../../lib/styles';
import Typography from '../../../presentational/Typography';
import Image from '../../../presentational/Image';
import Button from '../../../presentational/Button';
import { Member } from '../../../../models/user';

import membershipPanelStyles from './MembershipPanel_styles';
import Spacer from '../../Spacer';

export interface MembershipPanelProps {
  detailsMaleAvatarImage: string;
  detailsFemaleAvatarImage: string;
  detailsUndefinedGenderAvatarImage: string;
  detailsWelcomeText: string;
  detailsTitle: string;
  detailsManageSubscriptionsButtonText: string;
  detailsManageProfileButtonText: string;
  detailsUnsubscribedMemberWelcomeText: string;
  userInformation: Member;
  onSignOut?: () => void;
  isCloaked: boolean;
}

const MembershipPanel = (props: MembershipPanelProps) => {
  const {
    detailsMaleAvatarImage,
    detailsFemaleAvatarImage,
    detailsUndefinedGenderAvatarImage,
    detailsWelcomeText,
    detailsTitle,
    detailsManageSubscriptionsButtonText,
    detailsManageProfileButtonText,
    detailsUnsubscribedMemberWelcomeText,
    userInformation: { gender, given_names, avatar, dotDigital },
    onSignOut,
    isCloaked,
  } = props;
  const styles = useStyles(membershipPanelStyles());

  const avatarImage = 
    gender == 'M' ? 
      detailsMaleAvatarImage : 
      gender == 'F' ? detailsFemaleAvatarImage :
        detailsUndefinedGenderAvatarImage;

  return (
    <div className={`membershipPanel mt-0 ${styles.panel}`}>
      <div className={`membershipContainer ${styles.container}`}>

        {isCloaked && (
          <Spacer
            row
            width={1160}
            space={'m'}
            align={'center'}
            justify={'center'}
            className={`w-100 mb-0`}
          >
            <div
              className={`alert alert-warning text-center ${styles.alert}`}
              role="alert"
            >
              You are running in cloaked mode.
            </div>
          </Spacer>
        )}

        <div className={`membershipRow ${styles.row}`}>
          <div className={`profileCard ${styles.profileCard}`}>
            <div className={`profileCardRow ${styles.profileCardRow}`}>
              <Image
                width={150}
                resizeWidth={150}
                aspect={[1, 1]}
                border={'grey'}
                corner={'f'}
                src={avatar || avatarImage}
              />

              <div className={`profileCardText ${styles.profileCardText}`}>
                <Typography color={'white'}>
                  <h2>{detailsWelcomeText} {given_names || 'Member'}</h2>
                  <Button 
                    onClick={() => onSignOut && onSignOut()} 
                    color={'primary'} 
                    className={styles.panelButton}
                  >
                    Not you? 
                  </Button>                  
                </Typography>
              </div>
            </div>
          </div>

          <div className={`profileButtons ${styles.profileButtons}`}>
            <Typography>
              <h2 className='w-100 flex-grow-1'>
                {
                  //  unsubscribed user special welcome prompt
                  (dotDigital.status != 'Subscribed') ? 
                    detailsUnsubscribedMemberWelcomeText :
                    detailsTitle
                }
                {isCloaked && (<small>(Cloaked)</small>)}
              </h2>
            </Typography>
            <div
              className={`membershipPanelButtons d-flex flex-column`}
              style={{
                gap: '0.5rem',
              }}
            >
              <Button href={'#subscriptions'} color={'primary'} className={styles.panelButton}>
                {detailsManageSubscriptionsButtonText}
              </Button>
              <Button href={'#profile'} color={'primary'} className={styles.panelButton}>
                {detailsManageProfileButtonText}
              </Button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default MembershipPanel;
